import type { Season } from '../types'

/**
 * Season dropdown.
 *
 * @param includeAll - Adds an "All seasons" option whose value is `'all'`.
 */
export default function SeasonPicker({
  seasons,
  value,
  onChange,
  includeAll = false,
  label = 'Season',
}: {
  seasons: Season[]
  value: number | 'all'
  onChange: (next: number | 'all') => void
  includeAll?: boolean
  label?: string
}) {
  return (
    <label className="field" style={{ minWidth: 180 }}>
      <span className="field__label">{label}</span>
      <select
        className="select"
        value={String(value)}
        onChange={event => {
          const next = event.target.value
          onChange(next === 'all' ? 'all' : Number(next))
        }}
      >
        {includeAll && <option value="all">All seasons</option>}
        {seasons.map(season => (
          <option key={season.number} value={season.number}>
            {season.name}
            {season.isCurrent ? ' · current' : ''}
          </option>
        ))}
      </select>
    </label>
  )
}
